import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAYR6S2AIqsqROEXMid5AIHdGo_31SbZpM",
  authDomain: "buzd-6c06a.firebaseapp.com",
  projectId: "buzd-6c06a",
  storageBucket: "buzd-6c06a.appspot.com",
  messagingSenderId: "514958745630",
  appId: "1:514958745630:web:7ee504f6c0f9dc4d508e0f",
  measurementId: "G-Q6XX350R08",
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);

export { db, app, storage, firebaseConfig };
